import { render, staticRenderFns } from "./ConundrumSettings.vue?vue&type=template&id=4988e9fd"
import script from "./ConundrumSettings.vue?vue&type=script&lang=js"
export * from "./ConundrumSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports